import React from 'react';
import Library from "./components/Library"


function App() {
  return (
    <div>
      <h1 className='centered'>Wockrad Library</h1>
      <Library/>
    </div>
  )
}

export default App